import { useState } from "react";
import {
  Box,
  Button,
  Container,
  Paper,
  Typography,
  Alert,
  CircularProgress,
} from "@mui/material";
import { Google as GoogleIcon } from "@mui/icons-material";
import { useAdminAuth } from "../context/AdminAuthContext";

export default function Login() {
  const { signInWithGoogle, loading, error, clearError } = useAdminAuth();
  const [signingIn, setSigningIn] = useState(false);

  const handleGoogleSignIn = async () => {
    clearError();
    setSigningIn(true);
    try {
      await signInWithGoogle();
    } finally {
      setSigningIn(false);
    }
  };

  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "100vh",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Paper
          elevation={2}
          sx={{
            p: 4,
            width: "100%",
            textAlign: "center",
          }}
        >
          <Typography variant="h5" component="h1" gutterBottom>
            NomNom Admin
          </Typography>
          <Typography color="text.secondary" sx={{ mb: 3 }}>
            Sign in with a NomNom admin account to continue.
          </Typography>
          {error && (
            <Alert severity="error" onClose={clearError} sx={{ mb: 2 }}>
              {error}
            </Alert>
          )}
          <Button
            variant="contained"
            size="large"
            startIcon={
              signingIn ? (
                <CircularProgress size={20} color="inherit" />
              ) : (
                <GoogleIcon />
              )
            }
            onClick={handleGoogleSignIn}
            disabled={signingIn}
            fullWidth
          >
            {signingIn ? "Signing in…" : "Sign in with Google"}
          </Button>
        </Paper>
      </Box>
    </Container>
  );
}
